import styled from 'styled-components';

export const ContainerFooter = styled.div`
    width: 100%;
    padding-top: 2rem;
    margin-bottom: 1rem;

    > h2 {
        color: var(--color-black);
        font-family: 'Myriad Pro';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 130%;
    }

    > h3 {
        padding-top: 0.2rem;
        font-weight: 400;
        font-size: 16px;
        color: var(--color-black);
    }

    > p {
        padding-top: 0.4rem;
        font-weight: 400;
        font-size: 14px;
        color: var(--color-black);
    }
`;
